import { materiales } from "./libraryConstants";
import ApiURLs from "config/ApiURLs";

export const colections = [
  /* {
    displayText: "Todo Cirma",
    value: " ",
    selected: false,
    disabled: false,
    searchfields: [],
  },
  {
    value: "CIRMA-AH",
    displayText: "Archivo Histórico",
    selected: false,
    sortby: [
      {
        displayText: "Colección",
        selected: false,
        value: "sortisadgid",
      },
      {
        displayText: "Título",
        selected: false,
        value: "sorttitle",
      },
      {
        displayText: "Autor",
        selected: false,
        value: "sortauthor",
      },
      {
        displayText: "Fecha",
        selected: false,
        value: "sortdate",
      },
    ],
    searchfields: [
      {
        displayText: "Título",
        value: "titulo",
        type: "text",
      },
      {
        displayText: "Autor",
        value: "autor",
        type: "text",
      },
      {
        displayText: "Productor",
        value: "producer",
        type: "text",
      },
      // {
      //   displayText: "Fecha Inicial",
      //   value: "from",
      //   type: "text",
      // },
      // {
      //   displayText: "Fecha Final",
      //   value: "to",
      //   type: "text",
      // },
      // {
      //   displayText: "Idioma",
      //   value: "idioma",
      //   placeholder: "Todos los Idiomas",
      //   type: "dropDown",
      //   urlToFetch: `${ApiURLs.libraryApiUrl}language`,
      //   values: [],
      // },
      {
        displayText: "Colecciones",
        value: "isadg",
        placeholder: "Todas las colecciones",
        type: "select",
        urlToFetch: `${ApiURLs.ApiUrl}collections?forfilter=names&repository=CIRMA-AH`,
        values: [],
      },
    ],
  },
  {
    value: "CIRMA-BIB",
    displayText: "Biblioteca de Ciencias Sociales",
    selected: false,
    searchfields: [
      {
        displayText: "Título",
        value: "titulo",
        type: "text",
      },
      {
        displayText: "Autor",
        value: "autor",
        type: "text",
      },
      // {
      //   displayText: "Idioma",
      //   value: "idioma",
      //   placeholder: "Todos los Idiomas",
      //   type: "dropDown",
      //   urlToFetch: `${ApiURLs.libraryApiUrl}language`,
      //   values: [],
      // },
      {
        displayText: "Material",
        value: "material",
        placeholder: "Todos los Materiales",
        type: "select",
        multivalue: true,
        // urlToFetch: `${ApiURLs.libraryApiUrl}material`,
        values: materiales,
      },
    ],
    sortby: [
      {
        displayText: "Título",
        selected: false,
        value: "sorttitle",
      },
      {
        displayText: "Autor",
        selected: false,
        value: "sortauthor",
      },
      {
        displayText: "Clasificación",
        selected: false,
        value: "sortclasification",
      },
    ],
  },
  {
    value: "CIRMA-FG",
    displayText: "Fototeca Guatemala",
    selected: false,
    sortby: [
      {
        displayText: "Colección",
        selected: false,
        value: "sortisadgid",
      },
      {
        displayText: "Título",
        selected: false,
        value: "sorttitle",
      },
      {
        displayText: "Autor",
        selected: false,
        value: "sortauthor",
      },
      {
        displayText: "Fecha",
        selected: false,
        value: "sortdate",
      },
    ],
    searchfields: [
      {
        displayText: "Título",
        value: "titulo",
        type: "text",
      },
      {
        displayText: "Autor",
        value: "autor",
        type: "text",
      },
      {
        displayText: "Productor",
        value: "producer",
        type: "text",
      },
      // {
      //   displayText: "Fecha Inicial",
      //   value: "from",
      //   type: "text",
      // },
      // {
      //   displayText: "Fecha Final",
      //   value: "to",
      //   type: "text",
      // },
      // {
      //   displayText: "Idioma",
      //   value: "idioma",
      //   placeholder: "Todos los Idiomas",
      //   type: "dropDown",
      //   urlToFetch: `${ApiURLs.libraryApiUrl}language`,
      //   values: [],
      // },
      {
        displayText: "Colecciones",
        value: "isadg",
        placeholder: "Todas las colecciones",
        type: "select",
        urlToFetch: `${ApiURLs.ApiUrl}collections?forfilter=names&repository=CIRMA-FG`,
        values: [],
      },
    ],
  }, */
  {
    value: "TAMI",
    displayText: "TAMI",
    selected: false,
    isDefault: true,
    sortby: [
      {
        displayText: "Date",
        selected: false,
        value: "isodate",
      },
      {
        displayText: "Title",
        selected: false,
        value: "sorttitle",
      }
    ],
    respp: [
      {
        displayText: "10",
        selected: false,
        value: "10",
      },
      {
        displayText: "20",
        selected: false,
        value: "20",
      },
      {
        displayText: "50",
        selected: false,
        value: "50",
      }
    ],
    searchfields: [
      {
        displayText: "Content Type",
        value: "contenttype",
        type: "select",
        values: [
          { value: "rich_media_archive", label: "Videos" },
          { value: "glifos_photographs", label: "Photographs" },
          { value: "glifos_digital_archive", label: "Documents" },
        ],
      },
      {
        displayText: "From",
        value: "datefrom",
        type: "date",
      },
      {
        displayText: "To",
        value: "dateto",
        type: "date",
      },
      {
        displayText: "Language",
        value: "language",
        type: "select",
        //urlToFetch: `${ApiURLs.ApiUrl}/glifos/api/video/category`,

        values: [
          {
            "value": "",
            "label": "--"
          },
          {
            "value": "eng",
            "label": "en - English"
          },
          {
            "value": "kin",
            "label": "kin - Kinyarwanda"
          },
          {
            "value": "fr",
            "label": "fr - French"
          }
        ],
      },
      {
        displayText: "Time Period",
        value: "timeperiod",
        type: "select",
        //urlToFetch: `${ApiURLs.ApiUrl}/glifos/api/video/category`,
        values: [
          {
            "value": "",
            "label": "--"
          },
          {
            "value": "1900-1916",
            "label": "1900-1916"
          },
          {
            "value": "1916-1924",
            "label": "1916-1924"
          },
          {
            "value": "1924-1962",
            "label": "1924-1962"
          },
          {
            "value": "Rwanda 1962 (1 July) - 1973 (4 July)",
            "label": "Rwanda 1962 (1 July) - 1973 (4 July)"
          },
          {
            "value": "Rwanda 1973 (5 July) - 1994 (6 April)",
            "label": "Rwanda 1973 (5 July) - 1994 (6 April)"
          },
          {
            "value": "Rwanda 1994 (7 April - 3 July)",
            "label": "Rwanda 1994 (7 April - 3 July)"
          },
          {
            "value": "Rwanda 1994 (4 July - 18 July)",
            "label": "Rwanda 1994 (4 July - 18 July)"
          },
          {
            "value": "Rwanda 1994 (19 July) - 2000 (23 March)",
            "label": "Rwanda 1994 (19 July) - 2000 (23 March)"
          },
          {
            "value": "Rwanda 2000 (March 24) - 2003 (September 11)",
            "label": "Rwanda 2000 (March 24) - 2003 (September 11)"
          },
          {
            "value": "Rwanda 2003 (September 12) - present",
            "label": "Rwanda 2003 (September 12) - present"
          }
        ],
      },
    ],
  }
];
